<script>
/**
 * This mixin provides theme property
 * It's not meant to be used directly.
 *
 * @mixin
 */
const THEME_LIGHT = 'light';
const THEME_DARK = 'dark';
const THEME_GREEN = 'green';
const THEME_GREY = 'grey';

export default {
    props: {
        /**
         * Component's theme
         * Possible values are: 'light', 'dark', 'green', 'grey'.
         */
        theme: {
            type: String,
            default: THEME_LIGHT,
            validator: value => [THEME_LIGHT, THEME_DARK, THEME_GREEN, THEME_GREY].includes(value)
        }
    },
    created () {
        this.$options.theme = {
            light: THEME_LIGHT,
            dark: THEME_DARK,
            green: THEME_GREEN,
            grey: THEME_GREY
        };
    }
};
</script>
